import { useForm } from "react-hook-form";
import { DataContext } from 'providers/data';
import { useState, useContext, useEffect } from 'react';

import * as Regex from 'utils/validations';
import { ParamsDataFinancialPending } from 'utils/typeServices';

import LoadingButton from '@mui/lab/LoadingButton';
import { Box, Button, Typography } from '@mui/material';

import Input from 'components/views/form/Input';
import Select from 'components/views/form/Select';
import TooltipButton from 'components/views/TooltipButton';
import { ButtonRectangle } from 'components/views/form/Button';
import { ModalConfirmedEmailExternal, ModalConfirmChangeCreditCard, ModalErrorCreditCard, ModalErrorPaymentKey } from 'components/views/Invoices/Modals';

import CircularProgress from '@mui/material/CircularProgress';
import { ReactComponent as IcSendEmail } from 'assets/icons/ic-send-email.svg';
import { ReactComponent as IcDownloadTicket } from 'assets/icons/ic-download-ticket.svg';
import { ReactComponent as IcCopyAndPasteTicket } from 'assets/icons/ic-copy-and-paste-ticket.svg';

import { BoxContentInput } from './styles';

type ParamsCreditCard = {
    email: string;
    name: string;
    flag: string;
    numberCard: string;
    validity: string;
    cvv: string;
    parcel: string;
}

type ParamsSelected = {
    text: string;
    value: string;
}

const styleBtn = {
    width: '33%',
    padding: {
        xs: '0 .5rem',
        md: '0'
    },
    fontWeight: 700,
    fontSize: '.75rem',
    height: '2.1875rem',
    borderRadius: '100px',
}

const styleBtnTicket = {
    gap: '.625rem',
    fontWeight: 700,
    color: '#0AA8E3',
    fontSize: '1rem',
    borderRadius: '5px',
    border: '2px solid #0AA8E3',
    padding: '.65rem .9375rem .4rem',
    '&:hover': {
        border: '2px solid #0AA8E3'
    }
}

const PayInvoiceExternal = ({ financialPendingSelected, handleChangeReturn }: { financialPendingSelected: ParamsDataFinancialPending, handleChangeReturn: () => void }) => {
    const [valueTotal, setValueTotal] = useState(0);
    const [selectedBtn, setSelectedBtn] = useState(0);
    const [disabledBtnPaymentCard, setDisabledBtnPaymentCard] = useState(true);
    const [selectedTypeEmail, setSelectedTypeEmail] = useState<'ticket' | 'pix'>('ticket');
    const [isOpenModalEmail, setIsOpenModalEmail] = useState(false);
    const [cardSelected, setCardSelected] = useState<ParamsSelected>();
    const [cardList, setCardList] = useState<Array<ParamsSelected>>([]);
    const [parcelSelected, setParcelSelected] = useState<ParamsSelected>();
    const [isLoadingBtn, setIsLoadingBtn] = useState(false);
    const [isOpenModalCredidCard, setIsOpenModalCredidCard] = useState(false);
    const [isOpenModalErrorPaymentKey, setIsOpenModalErrorPaymentKey] = useState(false);
    const [dataFinancialPendingSelected, setDataFinancialPendingSelected] = useState<ParamsDataFinancialPending>(financialPendingSelected);
    const { dataFinancialPending, dataGenerateBillingPix, dataGenerateBillingTicket, dataListarFormaPagamentoPorCanalVenda, dataGerarCobranca, handlePostGerarCobranca, handlePostGenerateBilling, handleDataGerarCobranca } = useContext(DataContext);

    const { register, watch, setValue, formState: { errors } } = useForm<ParamsCreditCard>();

    const cvv = watch().cvv;
    const name = watch().name;
    const email = watch().email;
    const validity = watch().validity;
    const numberCard = watch().numberCard;

    const handleDonwloadTicket = () => {
        if (dataGenerateBillingTicket?.Pdf) {
            const b64toBlob = (b64Data: string, contentType = '', sliceSize = 512) => {
                const byteCharacters = atob(b64Data);
                const byteArrays = [];

                for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    const slice = byteCharacters.slice(offset, offset + sliceSize);

                    const byteNumbers = new Array(slice.length);
                    for (let i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }

                    const byteArray = new Uint8Array(byteNumbers);
                    byteArrays.push(byteArray);
                }

                const blob = new Blob(byteArrays, { type: contentType });
                return blob;
            }

            const blob = b64toBlob(dataGenerateBillingTicket?.Pdf);
            const blobUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');

            link.href = blobUrl;
            link.setAttribute('download', 'boleto.pdf');
            document.body.appendChild(link);
            link.click();
        }
    }

    const handleSendEmail = (type: 'ticket' | 'pix') => {
        setSelectedTypeEmail(type);
        setIsOpenModalEmail(true);
    }

    const handlePaymentCreditCard = () => {
        setIsLoadingBtn(true);

        if (dataFinancialPendingSelected && parcelSelected && cardSelected) {
            handlePostGerarCobranca({
                token: localStorage.getItem('token')!,
                body: {
                    CARTAO_CREDITO: {
                        CODIGO_SEGURANCA: cvv,
                        NM_NOME: name,
                        NR_ANO_VALIDADE: `20${validity?.split('/')[1]}`,
                        NR_MES_VALIDADE: validity?.split('/')[0],
                        NR_NUMERO: numberCard?.replace(/\s/g, ''),
                        NR_PARCELAS: parseFloat(parcelSelected?.value)
                    },
                    CD_FORMA_PAGAMENTO: parseFloat(cardSelected?.value),
                    CHAVE_PAGAMENTO: dataFinancialPendingSelected?.CHAVE_PAGAMENTO,
                    EMAIL: email,
                    validade_cartao: validity
                }
            });
        }
    }

    const handleGetSelected = (type: number) => {
        setSelectedBtn(type);

        if (type === 1) {
            if (!dataGenerateBillingTicket?.Pdf && dataFinancialPendingSelected) {
                handlePostGenerateBilling({
                    token: localStorage.getItem('token')!,
                    body: { CHAVE_PAGAMENTO: dataFinancialPendingSelected?.CHAVE_PAGAMENTO!, CD_FORMA_PAGAMENTO: dataFinancialPendingSelected?.CD_FORMA_PAGAMENTO! },
                    type: 'ticket'
                });
            }
        } else {
            if (!dataGenerateBillingPix?.PixQrCodeBase64 && dataFinancialPending) {
                handlePostGenerateBilling({
                    token: localStorage.getItem('token')!,
                    body: { CHAVE_PAGAMENTO: dataFinancialPendingSelected?.CHAVE_PAGAMENTO!, CD_FORMA_PAGAMENTO: dataFinancialPendingSelected?.CD_FORMA_PAGAMENTO! },
                    type: 'pix'
                });
            }
        }
    }

    useEffect(() => {
        if (cvv?.match(/[0-9]{3}/) && cardSelected && name?.match(Regex.name) && email?.match(Regex.email) && parcelSelected?.value && validity?.match(Regex.validationCardCredit) && numberCard?.replace(/[^0-9]/g, '').match(/^[0-9]{14,16}$/i)) {
            setDisabledBtnPaymentCard(false);
        } else {
            setDisabledBtnPaymentCard(true);
        }
    }, [cvv, cardSelected, name, email, parcelSelected, validity, numberCard]);

    useEffect(() => {
        if (dataListarFormaPagamentoPorCanalVenda) {
            let auxListCard: Array<ParamsSelected> = [];

            dataListarFormaPagamentoPorCanalVenda.map(({ NM_BANCO, CD_FORMA_PAGAMENTO }) =>
                auxListCard.push({ text: NM_BANCO, value: CD_FORMA_PAGAMENTO.toString() })
            );

            auxListCard && setCardList(auxListCard);
        }
    }, [dataListarFormaPagamentoPorCanalVenda]);

    useEffect(() => {
        if (dataGerarCobranca) {
            setIsOpenModalCredidCard(true);
        } else if (dataGerarCobranca === false) {
            setIsOpenModalCredidCard(true);
        }

        if (dataGerarCobranca !== undefined) {
            setIsLoadingBtn(false);
        }
    }, [dataGerarCobranca]);

    useEffect(() => {
        if (financialPendingSelected) {
            setDataFinancialPendingSelected(financialPendingSelected);
            setValue('cvv', '');
            setValue('name', '');
            setValue('email', '');
            setValue('validity', '');
            setValue('numberCard', '');
            setIsOpenModalCredidCard(false);
            setCardSelected({ text: '', value: '' });

            const splitValue = financialPendingSelected?.VL_ATUALIZADO.split(' ')[1];
            splitValue && setValueTotal(parseFloat(splitValue.replace(/\./g, '').replace(',', '.')));
            setParcelSelected(
                {
                    text: `1x de R$ ${valueTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
                    value: '1'
                },
            )
            handleDataGerarCobranca();
        }
        setIsLoadingBtn(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [financialPendingSelected]);

    useEffect(() => {
        if (dataGenerateBillingPix?.IsError && dataGenerateBillingTicket?.IsError) {
            setIsOpenModalErrorPaymentKey(true);
        }
    }, [dataGenerateBillingTicket, dataGenerateBillingPix]);

    return (
        <Box sx={{
            width: '100%',
            maxWidth: '50rem',
            paddingBottom: {
                xs: '1.56rem',
                md: 0
            }
        }}>
            <Box>
                <Box
                    sx={{
                        display: 'flex',
                        gap: '.375rem',
                        justifyContent: 'space-between',
                        paddingBottom: {
                            xs: '1.1875rem',
                            md: '.5rem',
                            lg: '1.1875rem'
                        },
                        flexDirection: {
                            xs: 'column',
                            md: 'row'
                        }
                    }}
                >
                    <Typography variant='body2' fontWeight={400} color='grey.400'>
                        Empresa:&nbsp;&nbsp;
                        <strong style={{ fontSize: '1rem' }}>
                            {dataFinancialPendingSelected && dataFinancialPendingSelected?.NM_EMPRESA}
                        </strong>
                    </Typography>
                    <Typography variant='body2' fontWeight={400} color='grey.400'>
                        Vencimento:&nbsp;&nbsp;
                        <strong style={{ fontSize: '1rem' }}>
                            {dataFinancialPendingSelected && dataFinancialPendingSelected?.DT_VENCIMENTO}
                        </strong>
                    </Typography>
                    <Typography variant='body2' fontWeight={400} color='grey.400'>
                        Valor atual:&nbsp;&nbsp;
                        <strong style={{ fontSize: '1rem' }}>
                            {dataFinancialPendingSelected && dataFinancialPendingSelected?.VL_ATUALIZADO}
                        </strong>
                    </Typography>
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        paddingBottom: {
                            xs: '.93rem',
                            md: '.5rem',
                            lg: '1.125rem',
                        },
                        alignItems: {
                            xs: 'start',
                            md: 'center',
                        },
                        flexDirection: {
                            xs: 'column',
                            md: 'row'
                        }
                    }}>
                    <Typography variant='body2' fontWeight={400}
                        sx={{
                            marginBottom: {
                                xs: '.43rem',
                                md: 0
                            }
                        }}>
                        Formas de pagamento:
                    </Typography>

                    <Box sx={{
                        display: 'flex',
                        justifyContent: {
                            xs: 'space-between',
                            md: 'start'
                        },
                        gap: {
                            xs: '0',
                            md: '2%'
                        },
                        width: {
                            xs: '100%',
                            md: 'calc(100% - 8.5rem)'
                        }
                    }}>
                        <Button sx={styleBtn} variant={selectedBtn === 0 ? 'contained' : 'outlined'} onClick={() => setSelectedBtn(0)}>
                            CARTÃO DE CRÉDITO
                        </Button>
                        <Button sx={styleBtn} variant={selectedBtn === 1 ? 'contained' : 'outlined'} onClick={() => handleGetSelected(1)}>
                            BOLETO
                        </Button>
                        <Button sx={styleBtn} variant={selectedBtn === 2 ? 'contained' : 'outlined'} onClick={() => handleGetSelected(2)}>
                            PIX
                        </Button>
                    </Box>
                </Box>

                <Typography
                    variant='subtitle2'
                    fontWeight={400}
                    sx={{
                        lineHeight: '1.5rem',
                        paddingBottom: {
                            xs: '.93rem',
                            md: '.3rem',
                            lg: '.93rem'
                        },
                        marginBottom: {
                            xs: '.625rem',
                            md: '.25rem',
                            lg: '.625rem'
                        },
                        borderBottom: '1px solid rgba(141, 155, 181, 0.35)'
                    }}>
                    {selectedBtn === 0 && 'Lembramos que pagamentos efetuados no cartão de crédito levam 24 horas úteis para baixa.'}
                    {selectedBtn === 1 &&
                        <>
                            O pagamento desta fatura <strong>não</strong> quita valores em aberto.
                            <br />
                            A liquidação só ocorre após confirmação do banco.
                        </>
                    }
                    {selectedBtn === 2 && 'Copie o código PIX abaixo ou use o seu leitor de QR Code e cole em seu app de pagamento.'}
                </Typography>

                <Box>
                    <Typography variant='h6' fontWeight={700}
                        sx={{
                            lineHeight: {
                                xs: '1rem',
                                md: '2rem'
                            },
                            margin: {
                                xs: '1.375rem 0 1.4375rem',
                                md: '0 0 0rem',
                                lg: '0 0 .75rem'
                            }
                        }}>
                        {selectedBtn === 0 && 'Dados do cartão:'}
                        {selectedBtn === 1 && 'Selecione a forma de como deseja receber seu boleto:'}
                    </Typography>

                    {selectedBtn === 0 &&
                        <form>
                            <BoxContentInput>
                                <Input
                                    name='email'
                                    label='E-mail'
                                    placeholder='E-mail para envio do comprovante'
                                    type='text'
                                    error={errors.name}
                                    textError='Inserir e-mail válido'
                                    register={{ ...register("email", { pattern: Regex.email }) }}
                                />
                                <Input
                                    name='name'
                                    label='Nome (como está no cartão)'
                                    placeholder='Nome'
                                    type='text'
                                    error={errors.name}
                                    textError='Inserir nome válido'
                                    register={{ ...register("name", { pattern: Regex.name }) }}
                                />
                            </BoxContentInput>

                            <BoxContentInput>
                                <Box sx={{
                                    width: '100%',
                                    marginBottom: {
                                        xs: '1.56rem',
                                        md: '0'
                                    }
                                }}>
                                    <Select
                                        label='Bandeira'
                                        placeholder="Selecione a bandeira"
                                        listItems={cardList}
                                        itemSelected={cardSelected}
                                        onChangeSelected={(e) => setCardSelected(e)}
                                    />
                                </Box>
                                <Input
                                    name='numberCard'
                                    label='Número do cartão'
                                    placeholder={parseFloat(cardSelected?.value || '0') === 12 ? '0000 000000 00000' : '0000 0000 0000 0000'}
                                    maskHolder={parseFloat(cardSelected?.value || '0') === 12 ? '9999 999999 99999' : '9999 9999 9999 9999'}
                                    error={errors.numberCard}
                                    type='tel'
                                    mask
                                    textError='Número do cartão obrigatório'
                                    register={{ ...register("numberCard", { required: true }) }}
                                />
                            </BoxContentInput>

                            <BoxContentInput>
                                <Box sx={{ display: 'flex', width: '100%', gap: '13%' }}>
                                    <Input
                                        name='validity'
                                        label='Validade'
                                        placeholder='00/00'
                                        maskHolder='99/99'
                                        type='tel'
                                        mask
                                        error={errors.validity}
                                        textError='Validade obrigatória'
                                        register={{ ...register("validity", { pattern: Regex.validationCardCredit }) }}
                                    />
                                    <Input
                                        name='cvv'
                                        label='CVV'
                                        placeholder={parseFloat(cardSelected?.value || '0') === 12 ? '0000' : '000'}
                                        maskHolder={parseFloat(cardSelected?.value || '0') === 12 ? '9999' : '999'}
                                        type='tel'
                                        mask
                                        error={errors.cvv}
                                        textError="Código obrigatório"
                                        register={{ ...register("cvv", { pattern: /^[0-3]{3}$/i }) }}
                                    />
                                </Box>

                                <Select
                                    label='Parcelas'
                                    placeholder="A vista"
                                    itemSelected={parcelSelected}
                                    listItems={[
                                        { text: `1x de R$ ${valueTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, value: '1' },
                                        { text: `2x de R$ ${(valueTotal / 2).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, value: '2' },
                                        { text: `3x de R$ ${(valueTotal / 3).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, value: '3' },
                                    ]}
                                    onChangeSelected={(e) => setParcelSelected(e)}
                                />
                            </BoxContentInput>

                            <BoxContentInput>
                                <Box sx={{ width: '100%' }} />
                                <Box sx={{
                                    width: '100%',
                                    'button': { width: '100%' },
                                    margin: {
                                        xs: '1.56rem 0 0',
                                        md: '.5rem 0 0'
                                    }
                                }}>
                                    <ButtonRectangle disabled={disabledBtnPaymentCard} loadingBtn={isLoadingBtn} name='PAGAR' onClick={() => handlePaymentCreditCard()} />
                                </Box>
                            </BoxContentInput>
                        </form>
                    }

                    {selectedBtn === 1 &&
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                flexDirection: {
                                    xs: 'column',
                                    md: 'row'
                                },
                                gap: {
                                    xs: '1.25rem'
                                },
                                'button': {
                                    width: {
                                        xs: '100%',
                                        md: 'fit-content'
                                    }
                                }
                            }}>
                            <TooltipButton>
                                <LoadingButton
                                    sx={styleBtnTicket}
                                    variant='outlined'
                                    loading={dataGenerateBillingTicket?.Digitavel ? false : true}
                                    onClick={() => navigator.clipboard.writeText(dataGenerateBillingTicket?.Digitavel || '')}
                                >
                                    COPIAR CÓDIGO
                                    <IcCopyAndPasteTicket />
                                </LoadingButton>
                            </TooltipButton>
                            <TooltipButton text='Baixado'>
                                <LoadingButton sx={styleBtnTicket} variant='outlined' loading={dataGenerateBillingTicket?.Pdf ? false : true} onClick={() => handleDonwloadTicket()}>
                                    BAIXAR BOLETO
                                    <IcDownloadTicket />
                                </LoadingButton>
                            </TooltipButton>
                            <Button
                                sx={styleBtnTicket}
                                variant='outlined'
                                onClick={() => handleSendEmail('ticket')}
                            >
                                ENVIO POR E-MAIL
                                <IcSendEmail />
                            </Button>
                        </Box>
                    }

                    {selectedBtn === 2 &&
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Box sx={{
                                width: '8.75rem',
                                height: '8.75rem',
                                borderRadius: '9.33px',
                                marginBottom: '1.125rem',
                                border: '7px solid #0C1C33',
                                'img': {
                                    width: '100%',
                                    height: '100%',
                                }
                            }}>
                                {dataGenerateBillingPix?.PixQrCodeBase64 ?
                                    <img src={`data:image/png;base64, ${dataGenerateBillingPix?.PixQrCodeBase64}`} alt="teste" />
                                    :
                                    <Box sx={{
                                        height: '100%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <CircularProgress />
                                    </Box>
                                }
                            </Box>
                            <Box
                                sx={{
                                    display: 'grid',
                                    gap: '1.5rem',
                                    gridTemplateRows: {
                                        xs: '1fr 1fr',
                                        md: '1fr'
                                    },
                                    gridTemplateColumns: {
                                        xs: '1fr',
                                        md: '1fr 1fr',
                                    },
                                    'button': {
                                        width: '100%'
                                    }
                                }}>
                                <TooltipButton>
                                    <LoadingButton
                                        sx={styleBtnTicket}
                                        variant='outlined'
                                        loading={dataGenerateBillingPix?.PixQrCode ? false : true}
                                        onClick={() => navigator.clipboard.writeText(dataGenerateBillingPix?.PixQrCode || '')}
                                    >
                                        COPIAR CÓDIGO
                                        <IcCopyAndPasteTicket />
                                    </LoadingButton>
                                </TooltipButton>
                                <Button
                                    sx={styleBtnTicket}
                                    variant='outlined'
                                    onClick={() => handleSendEmail('pix')}
                                >
                                    ENVIO POR E-MAIL
                                    <IcSendEmail />
                                </Button>
                            </Box>
                        </Box>
                    }
                </Box>
            </Box>
            <ModalConfirmedEmailExternal
                open={isOpenModalEmail}
                handleClick={(e) => setIsOpenModalEmail(e)}
                CHAVE_PAGAMENTO={dataFinancialPendingSelected ? dataFinancialPendingSelected?.CHAVE_PAGAMENTO : ''}
                CD_FORMA_PAGAMENTO={dataFinancialPendingSelected ? dataFinancialPendingSelected?.CD_FORMA_PAGAMENTO : 0}
                type={selectedTypeEmail}
            />

            {dataGerarCobranca &&
                <ModalConfirmChangeCreditCard
                    open={isOpenModalCredidCard}
                    isExternal={true}
                    handleClick={(e) => { setIsOpenModalCredidCard(e); handleChangeReturn(); }}
                />
            }

            {dataGerarCobranca === false &&
                <ModalErrorCreditCard
                    open={isOpenModalCredidCard}
                    handleClick={(e) => setIsOpenModalCredidCard(e)}
                />
            }

            <ModalErrorPaymentKey
                open={isOpenModalErrorPaymentKey}
                handleClick={(e) => { setIsOpenModalErrorPaymentKey(e); handleChangeReturn(); }}
            />
        </Box>
    );
}

export default PayInvoiceExternal;